import {
    Shield,
    Sparkles,
    LineChart,
    Flower2,
    PiggyBank,
    HeartPulse,
    Stethoscope,
    Smile,
} from "lucide-react";

export const PRODUCTS = [
    {
        key: "Term",
        title: "Term Life",
        icon: Shield,
        short: "Affordable coverage for 10, 20, or 30 years.",
        long: "Pure protection for a defined period — ideal when you have a mortgage, young kids, or a term of life you specifically want to cover.",
    },
    {
        key: "Whole Life",
        title: "Whole Life",
        icon: Sparkles,
        short: "Permanent protection with guaranteed cash value.",
        long: "Lifetime coverage that builds predictable cash value. Designed for clients who want certainty and a legacy component.",
    },
    {
        key: "IUL",
        title: "Indexed Universal Life",
        icon: LineChart,
        short: "Permanent coverage tied to market indexes — with downside protection.",
        long: "Flexible permanent coverage with cash value that participates in index gains, with guardrails against losses.",
    },
    {
        key: "Final Expense",
        title: "Final Expense",
        icon: Flower2,
        short: "Compact whole life for end-of-life costs.",
        long: "Smaller permanent policies designed to cover funeral, burial, and outstanding medical expenses so family isn't left with the bill.",
    },
    {
        key: "Annuities",
        title: "Annuities",
        icon: PiggyBank,
        short: "Retirement income with principal protection.",
        long: "Tax-deferred accumulation and optional guaranteed income streams — a complement to Social Security and other retirement assets.",
    },
    {
        key: "Health",
        title: "Health",
        icon: HeartPulse,
        short: "Major medical for individuals, families, and self-employed.",
        long: "Qualified ACA and private plans matched to your state, providers, and budget.",
    },
    {
        key: "Medicare",
        title: "Medicare",
        icon: Stethoscope,
        short: "Medicare Advantage and Supplement guidance.",
        long: "Objective help comparing Advantage, Supplement (Medigap), and Part D options — across carriers licensed in your state.",
    },
    {
        key: "Dental/Vision",
        title: "Dental & Vision",
        icon: Smile,
        short: "Standalone or bundled dental and vision coverage.",
        long: "Round out medical coverage with dental and vision — standalone or paired with an existing plan.",
    },
];

export const CARRIERS = [
    { name: "Corebridge", slug: "corebridge", logo: "/brand/carriers/corebridge.png", blurb: "Large-scale term and whole life portfolio with broad underwriting niches." },
    { name: "Mutual of Omaha", slug: "mutual-of-omaha", logo: "/brand/carriers/mutual-of-omaha.png", blurb: "Trusted name in final expense and whole life for decades." },
    { name: "Kansas City Life", slug: "kansas-city-life", logo: "/brand/carriers/kansas-city-life.png", blurb: "Respected carrier across term, whole life, and annuity products." },
    { name: "National Life Group", slug: "national-life-group", logo: "/brand/carriers/national-life-group.png", blurb: "Strength in indexed universal life and annuity solutions." },
    { name: "Fidelity", slug: "fidelity", logo: "/brand/carriers/fidelity.png", blurb: "Reliable final expense and term life offerings." },
    { name: "Foresters", slug: "foresters", logo: "/brand/carriers/foresters.png", blurb: "Fraternal benefit carrier with member-focused extras." },
    { name: "Transamerica", slug: "transamerica", logo: "/brand/carriers/transamerica.png", blurb: "Long-standing IUL and term experience." },
    { name: "F&G", slug: "fg", logo: "/brand/carriers/fg.png", blurb: "Annuity specialists with competitive guaranteed-income products." },
];

export const NAV_LINKS = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About" },
    { to: "/coverage", label: "Coverage" },
    { to: "/carriers", label: "Carriers" },
    { to: "/how-it-works", label: "How It Works" },
    { to: "/jarvis", label: "Jarvis" },
    { to: "/blog", label: "Blog" },
    { to: "/join", label: "Join the Team" },
    { to: "/faq", label: "FAQ" },
    { to: "/contact", label: "Contact" },
];

export const COVERAGE_STATUS_OPTIONS = [
    { value: "none", label: "I don't have any coverage yet" },
    { value: "have some", label: "I have some coverage today" },
    { value: "shopping", label: "I'm actively shopping around" },
];

export const URGENCY_OPTIONS = [
    { value: "ASAP", label: "As soon as possible" },
    { value: "within 30 days", label: "Within 30 days" },
    { value: "1-3 months", label: "1–3 months" },
    { value: "Just exploring", label: "Just exploring" },
];

export const SEX_OPTIONS = [
    { value: "female", label: "Female" },
    { value: "male", label: "Male" },
    { value: "prefer not to say", label: "Prefer not to say" },
];

export const HOW_IT_WORKS_STEPS = [
    {
        n: 1,
        title: "Tell us about you",
        body: "Share a few details — either through our short form or a conversation with Jarvis, our AI concierge. No pressure, no cold calls.",
    },
    {
        n: 2,
        title: "Jarvis pre-qualifies",
        body: "Jarvis understands your goals and organizes the information a licensed advisor needs — so your first real conversation isn't a discovery call.",
    },
    {
        n: 3,
        title: "Advisor review",
        body: "A Moving Mountains advisor — licensed in your state — reviews the fit, pulls relevant options from our partner carriers, and prepares a tailored illustration.",
    },
    {
        n: 4,
        title: "Personalized recommendation",
        body: "You get a clear, side-by-side explanation of what we recommend and why. You decide. No pressure, no surprises.",
    },
];
